<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields['title']" label="Name" />
        </div>

        <div class="mt-5">
          <label class="label-input">Section Content</label>
          <v-select
            :value="fields['section-content-position']"
            :items="postionOptions"
            label="Content Position"
            @change="handleChangeSectionContentPosition"
          />
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="text-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['text-color']"
                  @change="handleChangeTextColor"
                />
                <v-text-field v-model="fields['text-color']" label="Text Color" />
                <v-btn @click="handleResetTextColor" small text color="primary">Reset</v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="background-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['background-color']"
                  @change="handleChangeBackgroundColor"
                />
                <v-text-field v-model="fields['background-color']" label="Background Color" />
                <v-btn @click="handleResetBackgroundColor" small text color="primary">Reset</v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <v-text-field v-model="fields['sale-text-1']" label="Sale Text 1" />
                <v-checkbox v-model="fields['sale-text-1-show']" dense />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <v-text-field v-model="fields['sale-text-2']" label="Sale Text 2" />
                <v-checkbox v-model="fields['sale-text-2-show']" dense />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <v-text-field v-model="fields['guarantee-text-1']" label="Guarantee Text 1" />
                <v-checkbox v-model="fields['guarantee-text-1-show']" dense />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <v-text-field v-model="fields['guarantee-text-2']" label="Guarantee Text 2" />
                <v-checkbox v-model="fields['guarantee-text-2-show']" dense />
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="mt-5">
          <label class="label-input">Button Settings</label>
          <v-text-field v-model="fields['button-text']" label="Button Text" class="mb-3" />
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="button-text-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['button-text-color']"
                  @change="handleChangeButtonTextColor"
                />
                <v-text-field v-model="fields['button-text-color']" label="Button Text Color" />
                <v-btn @click="handleResetButtonTextColor" small text color="primary">Reset</v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="button-bg-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['button-bg-color']"
                  @change="handleChangeButtonBgColor"
                />
                <v-text-field v-model="fields['button-bg-color']" label="Button Background Color" />
                <v-btn @click="handleResetButtonBgColor" small text color="primary">Reset</v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'purchase-incentive-section-editor',
  components: {},
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      postionOptions: [
        {
          text: 'Left',
          value: 'left',
        },
        {
          text: 'Center',
          value: 'center',
        },
        {
          text: 'Right',
          value: 'right',
        },
      ],
      fields: {
        title: 'Section Purchase Incentive',
        'text-color': '#000000',
        'background-color': '#ffffff',
        'sale-text-1': 'Sale: Live For 24 Hrs.',
        'sale-text-2': 'Stock: Only 7 Units Left!',
        'button-text': 'Order Now & Save 50%',
        'button-text-color': '#ffffff',
        'button-bg-color': '#5ca605',
        'guarantee-text-1': '180 Days Money Back Guarantee',
        'guarantee-text-2': 'Free Shipping For Bundle Orders',
        'section-content-position': 'center',
        'sale-text-1-show': true,
        'sale-text-2-show': true,
        'guarantee-text-1-show': true,
        'guarantee-text-2-show': true,
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleChangeTextColor(e) {
      this.fields['text-color'] = e.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '#000000';
    },
    handleChangeBackgroundColor(e) {
      this.fields['background-color'] = e.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '#ffffff';
    },
    handleChangeButtonTextColor(e) {
      this.fields['button-text-color'] = e.target.value;
    },
    handleResetButtonTextColor() {
      this.fields['button-text-color'] = '#ffffff';
    },
    handleChangeButtonBgColor(e) {
      this.fields['button-bg-color'] = e.target.value;
    },
    handleResetButtonBgColor() {
      this.fields['button-bg-color'] = '#5ca605';
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionPurchaseIncentive(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeSectionContentPosition(value) {
      this.fields['section-content-position'] = value;
    },
    handleChangeContentPaddingVertical(value) {
      this.fields['content-padding-vertical'] = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
